module.exports = __webpack_public_path__ + "img/footer-2.92eef756.png";